import {
  Box,
  Button,
  IconButton,
  Modal,
  Stack,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface IConfirmationModalProps {
  show: boolean
  innerHtml?: boolean
  size?: 'sm' | 'lg' | 'xl'
  dialogClassName?: string
  title: string
  titleClassName?: string
  message: string
  messageClassName?: string
  leftButtonText: string
  leftButtonClassName?: string
  leftButtonColor?: 'primary' | 'error' | 'inherit'
  rightButtonText: string
  rightButtonClassName?: string
  rightButtonColor?: 'primary' | 'error' | 'inherit'
  onClickLeftButton: (e?: any) => void
  onClickRightButton: (e?: any) => void
  onClickClose?: () => void
}

const getModalWidth = (size?: 'sm' | 'lg' | 'xl') => {
  switch (size) {
    case 'sm':
      return 360
    case 'lg':
      return 600
    case 'xl':
      return 800
    default:
      return 450
  }
}

export default function TwoButtonModal(props: IConfirmationModalProps) {
  return (
    <Modal
      open={props.show}
      onClose={props.onClickClose}
      sx={{ outline: 0 }}
      className="basic-modal"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: getModalWidth(props.size),
          maxWidth: '95vw',
          bgcolor: 'background.paper',
          transform: 'translate(-50%, -50%)',
          borderRadius: '8px',
          overflow: 'hidden',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="subtitle2"
            component="h3"
            sx={{ fontWeight: 700 }}
          >
            {props.title}
          </Typography>
          {props.onClickClose && (
            <IconButton onClick={props.onClickClose} size="small">
              <CloseIcon />
            </IconButton>
          )}
        </Stack>

        {/* Body */}
        <Box sx={{ mt: 2 }}>
          {props.innerHtml ? (
            <Typography
              variant="body2"
              component="div"
              dangerouslySetInnerHTML={{ __html: props.message }}
            />
          ) : (
            <Typography variant="body2">{props.message}</Typography>
          )}
        </Box>

        {/* Footer */}
        <Stack direction="row" justifyContent="flex-end" mt={2} gap={2}>
          {props.leftButtonText && (
            <Button
              variant="outlined"
              color={props.leftButtonColor || 'error'}
              onClick={props.onClickLeftButton}
            >
              {props.leftButtonText}
            </Button>
          )}
          {props.rightButtonText && (
            <Button
              variant="contained"
              color={props.rightButtonColor || 'primary'}
              onClick={props.onClickRightButton}
            >
              {props.rightButtonText}
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  )
}
